import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const PARTNER_TOKEN_KEY = 'partner_token';

const partnerApi = axios.create({
  baseURL: `${BACKEND_URL}/api/partner`,
  headers: { 'Content-Type': 'application/json' },
});

partnerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(PARTNER_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

partnerApi.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(PARTNER_TOKEN_KEY);
      if (!window.location.pathname.includes('/reseller/login')) {
        window.location.href = '/reseller/login';
      }
    }
    return Promise.reject(error.response?.data || error);
  }
);

export default partnerApi;
